import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class JobService {

  private readonly _layerButtonTrigger$ = new Subject<any>();
  public layerButtonTrigger$ = this._layerButtonTrigger$.asObservable();
  private readonly _horizontalButtonTrigger$ = new Subject<any>();
  public horizontalButtonTrigger$ = this._horizontalButtonTrigger$.asObservable();
  private readonly _verticalButtonTrigger$ = new Subject<any>();
  public verticalButtonTrigger$ = this._verticalButtonTrigger$.asObservable();
  private readonly _undoButtonTrigger$ = new Subject<any>();
  public undoButtonTrigger$ = this._undoButtonTrigger$.asObservable();
  private readonly _proceedButtonTrigger$ = new Subject<any>();
  public proceedButtonTrigger$ = this._proceedButtonTrigger$.asObservable();
  private readonly _undoTableChangesTrigger$ = new Subject<any>();
  public undoTableChangesTrigger$ = this._undoTableChangesTrigger$.asObservable();

  private readonly _changePageTrigger$ = new Subject<any>();
  public changePageTrigger$ = this._changePageTrigger$.asObservable();

  private readonly _jobVerifiedStatusTrigger$ = new Subject<any>();
  public jobVerifiedStatusTrigger$ = this._jobVerifiedStatusTrigger$.asObservable();

  private readonly _exportTrigger$ = new Subject<any>();
  public exportTrigger$ = this._exportTrigger$.asObservable();

  private readonly _headerToggleTrigger$ = new Subject<any>();
  public headerToggleTrigger$ = this._headerToggleTrigger$.asObservable();

  private readonly _onPopverAddCommentClickTrigger$ = new Subject<any>();
  public onPopverAddCommentClickTrigger$ = this._onPopverAddCommentClickTrigger$.asObservable();

  private readonly _onReprocessClickTrigger$ = new Subject<any>();
  public onReprocessClickTrigger$ = this._onReprocessClickTrigger$.asObservable();

  private readonly _proceedToNextJobTrigger$ = new Subject<any>();
  public proceedToNextJobTrigger$ = this._proceedToNextJobTrigger$.asObservable();

  private readonly _toolbarValues$ = new Subject<any>();
  public toolbarValues$ = this._toolbarValues$.asObservable();

  private readonly _infoButtonTrigger$ = new Subject<any>();
  public infoButtonTrigger$ = this._infoButtonTrigger$.asObservable();

  private readonly _deskewTrigger$ = new Subject<any>();
  public deskewTTrigger$ = this._deskewTrigger$.asObservable();

  constructor() {}


  setValues (value) {
    this._toolbarValues$.next(value);
  }

  horizontalButton () {
    this._horizontalButtonTrigger$.next();
  }

  verticalButton () {
    this._verticalButtonTrigger$.next();
  }

  undoButton () {
    this._undoButtonTrigger$.next();
  }

  proceedButton () {
    this._proceedButtonTrigger$.next();
  }

  async undoTableChanges () {
    this._undoTableChangesTrigger$.next();
  }

  headerToggle(e) {
    this._headerToggleTrigger$.next(e);
  }

  onReprocessClick () {
    this._onReprocessClickTrigger$.next();
  }

  onPopverAddCommentClick () {
    this._onPopverAddCommentClickTrigger$.next();
  }

  proceedToNextJob (res) {
    this._proceedToNextJobTrigger$.next(res);
  }

  async changePage(res) {
    this._changePageTrigger$.next(res);
  }

  jobVerifiedStatus(e) {
    return this._jobVerifiedStatusTrigger$.next(e);
  }

  export(e) {
    this._exportTrigger$.next(e);
  }

  layerButton () {
    this._layerButtonTrigger$.next();
  }

  infoClick () {
    this._infoButtonTrigger$.next();
  }

  deskew (res) {
    this._deskewTrigger$.next(res);
  }
}
